<div class="card mb-0" *ngIf="loading">
    <div class="card-body p-2">
        <div class="d-flex align-items-center">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while loading Counselling Details ...</span>
        </div>
    </div>
</div>
<div class="card mb-0" *ngIf="!loading && !counselling">
    <div class="card-body p-2">
        <div class="mh-400 position-relative">
            <no-data [title]="'Counselling Details'"></no-data>
        </div>
    </div>
</div>
<div class="card mb-0" *ngIf="!loading && counselling">
    <div class="card-body p-2">
        <fieldset class="form-fieldset">
            <legend class="text-primary">Counselling Details</legend>
            <div class="row row-sm">
                <div class="col-6 col">
                    <div class="form-group mb-0">
                        <label class="font-13 font-weight-bold mb-0">Package</label>
                        <p class="form-static-control" [textContent]="counselling.packageName"></p>
                    </div>
                </div>
                <div class="col-3 col">
                    <div class="form-group mb-0">
                        <label class="font-13 font-weight-bold mb-0">Charge Category</label>
                        <p class="form-static-control" [textContent]="counselling.chargeCategoryName"></p>
                    </div>
                </div>
                <div class="col-3 col">
                    <div class="form-group mb-0">
                        <label class="font-13 font-weight-bold mb-0">Counselling Type</label>
                        <p class="form-static-control" [textContent]="counselling.counsellingTypeName"></p>
                    </div>
                </div>
            </div>
        </fieldset>
        <fieldset class="form-fieldset">
            <legend class="text-primary">Payment Details</legend>
            <div class="row row-sm">
                <div class="col-6 col">
                    <div class="form-group">
                        <label class="font-13 font-weight-bold mb-0">Pay Type</label>
                        <p class="form-static-control" [textContent]="counselling.payTypeName || 'N/A'"></p>
                    </div>
                </div>
                <div class="col-6 col">
                    <div class="form-group">
                        <label class="font-13 font-weight-bold mb-0">Insurance Company</label>
                        <p class="form-static-control" [textContent]="counselling.insuranceCompanyName || 'N/A'"></p>
                    </div>
                </div>
                <div class="col-6 col">
                    <div class="form-group mb-0">
                        <label class="font-13 font-weight-bold mb-0">TPA Organization</label>
                        <p class="form-static-control" [textContent]="counselling.tpaName || 'N/A'"></p>
                    </div>
                </div>
                <!--<div class="col-6 col">
                    <div class="form-group mb-0">
                        <label class="font-13 font-weight-bold mb-0">Patient Organization</label>
                        <p class="form-static-control" [textContent]="counselling.patientOrganization || 'N/A'"></p>
                    </div>
                </div>-->
            </div>
        </fieldset>
        <fieldset class="form-fieldset">
            <legend class="text-primary">Package Details</legend>
            <view-package-module [packageModuleId]="counselling.packageModuleId" [isCounselling]="true" [chargeCategory]="chargeCategory"></view-package-module>
            <table class="table table-centered package-amounts mb-0 mt-2">
                <tbody>
                    <tr>
                        <td class="border-0">Total Quantity</td>
                        <td class="border-0" [textContent]="counselling.totalQuantity"></td>
                    </tr>
                    <tr>
                        <td>Sub Total</td>
                        <td [textContent]="counselling.subTotal | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                    <tr>
                        <td>Package Discount</td>
                        <td [textContent]="counselling.packageDiscount | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                    <tr>
                        <td>Counselling Discount</td>
                        <td [textContent]="counselling.discount | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                    <tr class="font-15 font-weight-bold">
                        <td>Counselling Total</td>
                        <td [textContent]="counselling.total | currency :'₹ ':'symbol':'1.2-2'"></td>
                    </tr>
                </tbody>
            </table>
        </fieldset>
        <div class="col-12 col">
            <div class="form-group pt-2">
                <label class="mb-0 font-weight-bold font-13">Comments</label>
                <p class="form-static-control" [textContent]="counselling.comments || 'N/A'"></p>
            </div>
        </div>
        <div class="row row-sm mt-3">
            <div class="col-6 col">
                <div class="form-group mb-0 d-flex flex-column">
                    <label class="font-13 font-weight-bold mb-0 text-primary">Counselling Given To</label>
                    <div class="d-flex font-13 align-items-center mb-1">
                        <p class="mb-0 font-weight-semibold text-capitalize">
                            <span [textContent]="counselling.patientName"></span>
                            <small *ngIf="counselling.patientGender" [textContent]="' (' + counselling.patientGender + ')'"></small>
                        </p>
                        <small class="text-mute ml-1" [textContent]="'/ ' + counselling.umrNo"></small>
                    </div>
                    <div class="signature-container"  [class.no-hover]="!counselling.isDraft" [class.has-image]="patientBase64Signature || counselling.patientSignature" (click)="onOpenModel(templateSignature, 'Counselling Given To')">
                        <img class="img-fluid" *ngIf="counselling.patientSignature" alt="Patient Signature" [src]="page.getImage(counselling.patientSignatureRootPath + counselling.patientSignature)" />
                        <ng-container *ngIf="!counselling.patientSignature">
                            <img class="img-fluid" alt="Patient Signature" *ngIf="patientBase64Signature" [src]="patientBase64Signature" />
                            <p><span class="mdi mdi-pencil-outline mr-1"></span> Signature</p>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="col-6 col">
                <div class="form-group mb-0 d-flex flex-column align-items-end">
                    <label class="font-13 font-weight-bold mb-0 text-primary">Counsellor<small class="ml-1">(Counselling Given By)</small></label>
                    <div class="d-flex font-13 align-items-center mb-1">
                        <p class="mb-0 font-weight-semibold text-capitalize" [textContent]="counselling.createdByName"></p>
                        <small class="text-mute ml-1" [textContent]="' / ' + (counselling.createdDate | amDateFormat : 'DD-MM-YYYY hh:mm a')"></small>
                    </div>
                    <div class="signature-container" [class.no-hover]="!counselling.isDraft" [class.has-image]="counsellorBase64Signature || counselling.counsellorSignature" (click)="onOpenModel(templateSignature, 'Counsellor')">
                        <img class="img-fluid" *ngIf="counselling.counsellorSignature" alt="Counsellor Signature" [src]="page.getImage(counselling.counsellorSignatureRootPath + counselling.counsellorSignature)" />
                        <ng-container *ngIf="!counselling.counsellorSignature">
                            <img class="img-fluid" alt="Counsellor Signature" *ngIf="counsellorBase64Signature" [src]="counsellorBase64Signature" />
                            <p><span class="mdi mdi-pencil-outline mr-1"></span> Signature</p>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="counselling.isDraft">
            <hr class="my-2" />
            <div class="d-flex align-items-center justify-content-end">
                <button type="button" (click)="onSubmit()" [disabled]="isSubmitting" class="btn btn-sm mb-0 ml-1 btn-primary">
                    <span *ngIf="isSubmitting">
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Please wait..
                    </span>
                    <span *ngIf="!isSubmitting">Publish</span>
                </button>
                <button type="button" (click)="onCancel()" [disabled]="isSubmitting" class="btn btn-sm mb-0 ml-1 btn-secondary">Cancel</button>
            </div>
        </ng-container>
    </div>
</div>
<ng-template #templateSignature>
    <div class="modal-header">
        <h4 class="modal-title">
            <span class="btn-group">
                <button type="button" class="btn btn-xs" [class.btn-warning]="signatureType === 'signature'" title="Signature" [class.btn-outline-light]="signatureType === 'digital'" (click)="signatureType = 'signature'">Draw</button>
                <button type="button" class="btn btn-xs" [class.btn-warning]="signatureType === 'digital'" title="Digital" [class.btn-outline-light]="signatureType === 'signature'" (click)="signatureType = 'digital'">Upload</button>
            </span>
            <span style="position: relative; top: 1px; left: 10px;">{{signatureFor}} Signature</span>
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
    </div>
    <div class="modal-body">
        <div class="d-flex align-items-center" *ngIf="isSaveSignature">
            <span class="spinner-grow text-warning" role="status" aria-hidden="true"></span>
            <span class="ml-2">Please wait while saving uploaded signature...</span>
        </div>
        <img-crop *ngIf="signatureType === 'digital'" [image]="null" [aspectRatio]="4/4" [resizeToWidth]="250" (croppedImageEmitter)="onReceiveDrewSignature($event)"></img-crop>
        <!--<image-drawing #imageId *ngIf="signatureType === 'signature'" src="assets/images/whiteBackground.png" outputQuality="0.5" borderCss="1px solid black" [showCancelButton]="false" [drawingSizes]="{ small: 3, medium: 5 }" width="400" height="250" (save)="onSaveUploadedSignature($event)">
        </image-drawing>-->
        <signature-widget *ngIf="signatureType === 'signature'" width="500"
                          height="200"
                          (done)="onSignatureDone($event)"></signature-widget>
    </div>
    <div class="modal-footer" *ngIf="signatureType === 'digital'">
        <button type="button" class="btn btn-sm btn-secondary mr-1" (click)="onCloseModal();">Close</button>
        <button type="button" (click)="onCloseModal()" class="btn btn-sm btn-primary">Submit</button>
    </div>
</ng-template>